// extracted by mini-css-extract-plugin
export default {"page":"GuidePage_page__v4t6k","toTop":"GuidePage_toTop__Od0S7","toTopShow":"GuidePage_toTopShow__pNf8P"};